import Immutable from 'immutable';
import camelCase from '../lib/camelCase';

export function softDelete(api, code, email) {
    return api.post(api.url(`users/${code}/deactivate`), { email }, {
        transformResponse(json) {
            const response = JSON.parse(json);
            if (response.payload) {
                return response && response.payload
                    ? Immutable.fromJS(camelCase(response.payload))
                    : response;
            }
            return response
                ? Immutable.fromJS(camelCase(response))
                : response;
        },
    });
}

export function updatePassword(api, currentPassword, newPassword, confirmedPassword) {
    return api.post(api.url(`users/update-password`), {
        'current_password': currentPassword,
        'password': newPassword,
        'password_confirmation': confirmedPassword,
    }, {
        transformResponse(json) {
            const response = JSON.parse(json);
            if (response.payload) {
                return response && response.payload
                    ? Immutable.fromJS(camelCase(response.payload))
                    : response;
            }
            return response
                ? Immutable.fromJS(camelCase(response))
                : response;
        },
    });
}

export function updateEmail(api, email) {
    return api.post(api.url(`users/update-email`), { email }, {
        transformResponse(json) {
            const response = JSON.parse(json);
            if (response.payload) {
                return response && response.payload
                    ? Immutable.fromJS(camelCase(response.payload))
                    : response;
            }
            return response
                ? Immutable.fromJS(camelCase(response))
                : response;
        },
    });
}

export default {
    softDelete,
    updatePassword,
    updateEmail,
};
